<template>
  <iframe ref="preview_iframe"
          frameborder="0"
          style="width: 100%; height: 100%;"></iframe>
</template>

<script>
import {ResourceImpl} from 'hal-client';

export default {
  name: 'preview',
  props: {
    referralsResource: ResourceImpl,
    form: Object
  },
  data () {
    return {
      html: null
    };
  },
  watch: {
    html: {
      immediate: true,
      handler (value) {
        if (value) {
          this.$refs.preview_iframe.srcdoc = value;
        }
      }
    }
  },
  mounted () {
    if (this.referralsResource && this.form) {
      const escapeTags = (value) => {
        if (typeof value === 'string') return value.replace(/</g, '--').replace(/>/g, '--');
        return value;
      };

      const encode = (queryObj, nesting) => {
        if (!queryObj) return;
        const pairs = Object.entries(queryObj).map(([key, val]) => {
          if (Array.isArray(val)) {
            return val
              .map(subVal => [nesting + key, escapeTags(subVal)].map(encodeURIComponent).join('='))
              .join('&');
          } else if (typeof val === 'object') {
            return encode(val, `${nesting}${key}.`);
          } else {
            
            return [nesting + key, escapeTags(val)].map(encodeURIComponent).join('=');
          }
        });
        return pairs.filter(item => !!item).join('&');
      };

      const previewParams = encode(this.form, '');

      this.$http.get(`${this.referralsResource.$href('preview')}?${previewParams}`)
        .then(res => {
          this.html = res.data;
        });
    }
  }
};
</script>

<style scoped>

</style>
